
import { campaignMixin } from "~/mixins";
import { sanitizeJsonLdStrings } from "~/utils/jsonld-sanitize";

export default {
  mixins: [campaignMixin],

  props: {
    product: { type: Object, default: () => {} },
    selectedVariant: { type: Object, default: () => {} },
    productImages: { type: Array, default: () => [] },
  },

  head() {
    if (!this.product) {
      return null;
    }

    const offers = [
      {
        "@type": "Offer",
        priceCurrency: "AUD",
        price: this.selectedVariant.price,
        itemCondition: "http://schema.org/NewCondition ",
        availability: "http://schema.org/InStock",
        url: `${this.$config.appEndPoint}${this.$route.fullPath}`,
        priceValidUntil: `${new Date().getFullYear()}-12-31`,
      },
      (this.isPublicSaleCampaign || this.isCanopySale) && {
        "@type": "AggregateOffer",
        offerCount: 1,
        lowPrice: this.isCanopySale ? this.price : this.enhancedUIPrice,
        highPrice: this.isCanopySale
          ? this.compareAtPrice
          : this.enhancedUIRRPrice,
        priceCurrency: "AUD",
      },
    ].filter(Boolean);

    const productJson = {
      "@context": "http://schema.org",
      "@type": "Product",
      name: this.product.title,
      image: this.productImages.map(x => x.src),
      description: this.product.description,
      sku: this.selectedVariant.sku,

      ...(this.product.brand_list && {
        brand: {
          "@type": "Brand",
          name: this.product.brand_list,
        },
      }),

      ...(this.ratingCount > 0 && {
        review: this.reviews.slice(0, 3).map(review => ({
          "@type": "Review",
          reviewRating: {
            "@type": "Rating",
            ratingValue: review.score,
          },
          author: {
            "@type": "Person",
            name: review.user.display_name,
          },
          reviewBody: review.content,
        })),

        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: this.bottomline.average_score,
          ratingCount: this.bottomline.total_review,
        },
      }),
      offers: offers.length === 1 ? offers[0] : offers,
      // adding return policy here since GMC is not able to ammend the 14 days return policy
      // https://schema.org/MerchantReturnPolicy
      hasMerchantReturnPolicy: {
        "@type": "MerchantReturnPolicy",
        applicableCountry: "AU",
        returnPolicyCountry: "AU",
        returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
      },
    };

    return {
      script: [
        {
          hid: `jsonld-${this.product.handle}`,
          type: "application/ld+json",
          json: sanitizeJsonLdStrings(productJson),
        },
      ],
    };
  },

  computed: {
    compareAtPrice() {
      return this.selectedVariant?.compareAtPrice;
    },
    price() {
      return this.selectedVariant.price;
    },
    isPublicSaleCampaign() {
      const publicSaleTitles = ["intro-price-campaign", "sale"];
      return publicSaleTitles.includes(this.campaignTitle);
    },
    isCanopySale() {
      return !!this.priorityCampaign?.value && !this.campaignTitle;
    },
  },

  created() {
    this.bottomline = this.$store.state.pdp.bottomline;
    this.reviews = this.$store.state.pdp.reviews ?? [];
    this.ratingCount = this.bottomline?.total_review ?? 0;
  },

  render() {
    return null;
  },
};
